import React__default from 'react';
import { kebabCase } from 'lodash';
import { NvTabsContext } from './NvTabsContext/NvTabsContext.esm.js';

var useTabs = function () {
    var _a = React__default.useContext(NvTabsContext), selectTab = _a.selectTab, currentTab = _a.currentTab;
    var isCurrentTab = function (tabId) {
        return currentTab === kebabCase(tabId);
    };
    return {
        currentTab: currentTab,
        isCurrentTab: isCurrentTab,
        selectTab: selectTab,
    };
};

export { useTabs };
//# sourceMappingURL=NvTabs.hooks.esm.js.map
